module.exports = __webpack_public_path__ + "static/img/Modelo.da655fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Modelo.png
// module id = 3Nd0
// module chunks = 0